module.exports = __webpack_public_path__ + "officialStatic/img/cj.25ff81d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/cj.png
// module id = Q8LK
// module chunks = 0